import React,{useState, useEffect} from 'react';
import Card from 'react-bootstrap/Card';
import Sides from '../Bars/Javasidebar';
import Button from 'react-bootstrap/Button'
import { Helmet } from "react-helmet";
function Jif() {

    const [padding, setWindowpadding] = useState(0);
  const [width, setWindowWidth] = useState(0);
  useEffect(() => {
    updateDimensions()

    window.addEventListener('resize', updateDimensions)
    return () => window.removeEventListener('resize', updateDimensions)
  }, [])

  const updateDimensions = () => {
    const width = window.innerWidth
    setWindowWidth(width)
    if (width < 998) {
      setWindowpadding(2.5)
    } else {
      setWindowpadding(14)
    }
  }

  
  
    return (
        <div>
      <Sides/>
      <Helmet>
 
 <title>Master the Java "if" Statement: A Beginner's Tutorial | CodeExampler</title>
<meta name="description" content="Learn how to use the Java if statement with CodeExampler's beginner tutorial. Make decisions and create logical expressions with ease using if and else statements." />
<meta name="keywords" content="Java if,else if ladder in java, Java if statement,nested if else in java, Java if condition, nested if statements java, coding for beginners, CodeExampler" />
<link rel="canonical" href="https://www.codeexampler.com/java-if" />
</Helmet>

<div className='lg:pl-56'>

            <h1 className="m-4 mh1">Java if statement</h1>
            <div className="first">
        <a href="/java-control-structure">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-if-else">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
            <p className="mt-4 para"> <span className="bold">Java if statement: </span>Java if Statement is used for making a decision.If and else can be a block</p>
            <h2 className="mt-4 mh2">Syntax of Java if statement Syntax:
            </h2>
          

           
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
            

  {"\n"}
  <span className="qwerty-10">if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">condition</span>
        <span className="qwerty-1">)</span>
  {"\n"}
  <span className="qwerty-3">&#123; </span>

  {"\n"}
  
        <span className="qwerty-4">&nbsp;&nbsp;body</span>
      {"\n"}
  <span className="qwerty-3">&#125; </span>

  

  {"\n"}
  {"\n"}
</code>
      </pre>        
    </div>



            <h2 className="headings">Q-Write a Program to input a number and check this number is more than or equal to 100 in Java if statement?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> if_example</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>          
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
    <span className="qwerty-4">a</span><span className="qwerty-8">=</span>
    <span className="qwerty-1">500;</span>
    
    {"\n"}
    <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty-8">&#60;</span> 
        <span className="qwerty-1">100</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"a is greater"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}

<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>

{"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;a is greater </span>          
          {"\n"}
       
            </code>{"   "}
            </pre>
      </div>
    </div>
    


<h2 className="headings">Q-Write a Program a number and print multiple no in Java if statement?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> if_example</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>          
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8"> ,</span>
    <span className="qwerty-4">b;</span>
    {"\n"}
    <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;a</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">1000;</span>
    <span className="qwerty-4">b</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">800;</span>
    {"\n"}
    <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty-8">&#60;</span> 
        <span className="qwerty-1">500</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"a is greater"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">b</span> 
        <span className="qwerty-8">&#60;</span> 
        <span className="qwerty-1">1000</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"b is less than 1000"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}
 

  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"all are correct"</span>
      <span className="qwerty-1">);</span>
      {"\n"}


<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>

{"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
    
        </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;a is greater </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;b is less than 1000 </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;all are correct </span>          
          {"\n"}
       
            </code>{"   "}
            </pre>
      </div>
    </div>




    <h2 className="headings">Q- Write a Program a number and print multiple if greater no in Java if statement?</h2>
    <div
      style={{
        background: "#0f0e33",
        width: "94%",
        marginLeft: "3%",
        paddingLeft: "2%",
        borderRadius: "20px",
      }}
    >
      <pre style={{ maxHeight: "500vh" }}>
        <code>
        
          {"\n"}
          <span className="qwerty-7">public </span>
          <span className="qwerty-5">class</span>
          <span className="qwerty-4"> if_example</span>
          
          {"\n"}
          <span className="qwerty-3">&#123; </span>
          {"\n"}
           
            <span className="qwerty-7">&nbsp; &nbsp;public </span>
          <span className="qwerty">static </span>
          <span className="qwerty-3">void </span>
          <span className="qwerty-8">main </span>
          <span className="qwerty-1">(</span>
          <span className="qwerty-2">String</span>
          <span className="qwerty-1">[] </span>
          <span className="qwerty-1">args</span>
          <span className="qwerty-1">) </span>
          {"\n"}
          <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#123; </span>          
      {"\n"}
      <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;int </span>
    <span className="qwerty-4">a</span>
    <span className="qwerty-8"> ,</span>
    <span className="qwerty-4">b</span>
    <span className="qwerty-8"> ,</span>
    <span className="qwerty-4">c;</span>
    {"\n"}
    <span className="qwerty-4">&nbsp;&nbsp;&nbsp;&nbsp;a</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">100;</span>
    <span className="qwerty-4">b</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">200;</span>
    <span className="qwerty-4">c</span>
    <span className="qwerty-8">=</span>
    <span className="qwerty-1">400;</span>
    {"\n"}
    <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty-8">&#62;</span> 
        <span className="qwerty-4">b</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"a is greater"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}
  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty-8">&#60;</span> 
        <span className="qwerty-4">b</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"b is greater"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}
 
  <span className="qwerty-5">&nbsp;&nbsp;&nbsp;&nbsp;if</span>
  <span className="qwerty-1">(</span>
        <span className="qwerty-4">a</span> 
        <span className="qwerty-8">&#60;</span> 
        <span className="qwerty-4">c</span>
        <span className="qwerty-1">)</span>
  {"\n"}

  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#123; </span>
  {"\n"} 
  <span className="qwerty-2">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;System</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">out</span>
      <span className="qwerty-8">.</span>
      <span className="qwerty-2">println</span>
      <span className="qwerty-1">(</span>
        <span className="qwerty-4">"c is greater"</span>
      <span className="qwerty-1">);</span>
      {"\n"}
  <span className="qwerty-3">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&#125; </span>
  {"\n"}





  {"\n"}
<span className="qwerty-3">&nbsp;&nbsp;&nbsp;&#125; </span>

{"\n"}
          <span className="qwerty-3">&#125; </span>
            {"\n"}
     </code>
      </pre>        
    </div>
    
    <div>
      <h3 className="headings">Output</h3>
      <div style={{background: '#0f0e33', width: '94%', marginLeft: '3%', paddingLeft: '2%', borderRadius: '20px' }}>
        <pre style={{ maxHeight: '500vh' }}>
          <code className="python hljs">
          {"\n"}
          <span className="qwerty-3">&nbsp;b is greater </span>          
          {"\n"}
          <span className="qwerty-3">&nbsp;c is greater </span>          
          {"\n"}
          
       
            </code>{"   "}
            </pre>
      </div>
    </div>


      <h1 className="mt-5">  </h1>
   
      <div className="back">
        <a href="/java-control-structure">   <Button className="ab" variant="primary" size="lg">&#60; Previous</Button></a> 
        <a href="/java-if-else">   <Button className="cd" variant="primary" size="lg"> Next &#62;</Button></a> 
        </div>
    </div></div>
    )

}
export default Jif;